import api from '../services/api';

const storyApi = {
    getAll: async () => {
        try {
            const response = await api.get('/stories');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/stories/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },


    // Create a new category
    create: async (formData) => {
        try {
            const response = await api.post('/stories', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.put(`/stories/${id}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/stories/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
};

export default storyApi;
